module.exports = __webpack_public_path__ + "img/logo.9cba4a79.png";